import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=ebac7d3e&"
import script from "./Paper.vue?vue&type=script&lang=ts&"
export * from "./Paper.vue?vue&type=script&lang=ts&"
import style0 from "./Paper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports